"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpQuestionStatusBadge = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Icon_1 = __importDefault(require("../../Icon/Icon"));
var DpQuestionStatusBadge_styled_1 = require("./DpQuestionStatusBadge.styled");
var DpQuestionStatusBadge = function (_a) {
    var multipleAttempts = _a.multipleAttempts, status = _a.status;
    var iconName = 'cross-check';
    if (status === 'correct') {
        iconName = multipleAttempts ? 'double-check' : 'check';
    }
    else if (status === 'incorrect') {
        iconName = multipleAttempts ? 'double-cross' : 'x';
    }
    return ((0, jsx_runtime_1.jsx)(DpQuestionStatusBadge_styled_1.StyledQuestionStatusBadge, { "data-testid": "question-status-badge", status: status, children: (0, jsx_runtime_1.jsx)(Icon_1.default, { name: iconName }) }));
};
exports.DpQuestionStatusBadge = DpQuestionStatusBadge;
exports.default = exports.DpQuestionStatusBadge;
